import { addUser } from "../../api/UserAdd";
import { toast } from "react-toastify";
import { useMutation, useQueryClient } from "react-query";
import UserCacheName from "../../utils/UserCacheName";
import { AxiosError } from "axios";
import ErrorUtils from "../../utils/ApiUtils/ErrorUtils";

export interface UserFormInputs {
  username: string;
  email: string;
  password?: string;
  confirmPassword?: string;
  roles: string[];
}

export function useAddUser(onSuccessCallback?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addUser,
    onSuccess: () => {
      toast.success("User saved successfully!");
      queryClient.invalidateQueries(UserCacheName.getUserList());

      if (onSuccessCallback) {
        onSuccessCallback();
      }
    },
    onError: (error: AxiosError) => {
      const errorMessage = ErrorUtils.getErrorMessage(error);
      toast.error(errorMessage);
    },
  });
}
